/**
 * @file ErrorsPage.tsx
 * @module app/modules/errors/ErrorsPage
 * @description Defines error routes for not-found, server-error, and maintenance pages.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

/* eslint-disable jsx-a11y/anchor-is-valid */
import { Route, Routes } from 'react-router-dom';
import { Error500 } from './components/Error500';
import { Maintanance } from './components/Maintanance';
import { Error404 } from './components/Error404';
import { ErrorsLayout } from './ErrorsLayout';
const ErrorsPage = () => (
  <Routes>
    <Route element={<ErrorsLayout />}>
      <Route
        path="404"
        element={<Error404 />}
      />
      <Route
        path="network"
        element={<Error500 />}
      />
      <Route
        path="maintanance"
        element={<Maintanance />}
      />
      <Route
        index
        element={<Error404 />}
      />
    </Route>
  </Routes>
);
export { ErrorsPage };
